import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18h12l4 -4h-12z","key":"svg-0"}],["path",{"d":"M8 14l-4 -4h12l4 4","key":"svg-1"}],["path",{"d":"M16 10l4 -4h-12l-4 4","key":"svg-2"}]]

const IconCurrencySolana = createReactComponent('outline', 'currency-solana', 'CurrencySolana', __iconNode);

export default IconCurrencySolana;